import { ApplicationTypeEnum, ProductTypeEnum } from '../../../legacy/shared-types';

export const productFormValuesFormatter = (key: string, value: any) => {
  switch (key) {
    case 'salesforceId':
    case 'productTier':
    case 'monthsInitial':
    case 'productFees':
      return Number(value);
    case 'productType':
      return value as ProductTypeEnum;
    case 'applicationType':
      return value as ApplicationTypeEnum;
    case 'closeDate':
    case 'launchDate':
      return value?.toDate() || '';
    case 'equityShare':
    case 'initialBaseRate':
    case 'initialMargin':
    case 'margin':
    case 'maximumFTV':
      return Number(value) / 100;
    case 'maxFti':
      return Number(value);
    default:
      return value;
  }
};
